import { ContainerApplicationController } from 'web-interactives-embed-framework';
import { createFormController } from 'ui-forms-embed-components-frame-container/controllers/FormController/FormControllerV4';
export class ApplicationController extends ContainerApplicationController {
  initHubspotForm() {
    createFormController({
      applicationController: this
    });
  }
}
export function createApplicationController() {
  return new ApplicationController();
}